/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcPortfolioV1AssetBalanceEvent } from '@interxfi/types';
import { schema } from 'normalizr';
import { ixcAssetsV1AssetStateEntity } from './ixc-assets-v1-asset-state';

export const IXC_PORTFOLIO_V1_ASSET_BALANCE_EVENT_ENTITY_NAME = 'ixc.portfolio.v1.AssetBalanceEvent';
export const ixcPortfolioV1AssetBalanceEventEntity = new schema.Entity<IxcPortfolioV1AssetBalanceEvent>(IXC_PORTFOLIO_V1_ASSET_BALANCE_EVENT_ENTITY_NAME, {
    event: new schema.Object({
        config: new schema.Object({
            asset: ixcAssetsV1AssetStateEntity
        })
    })
}, { idAttribute: (entity: IxcPortfolioV1AssetBalanceEvent) => `${entity.metadata?.eventId}` });

